export default function PolygonDropdownIcon() {
  return (
    <>
      <svg
        width="11"
        height="11"
        viewBox="0 0 7 7"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.36602 6C3.98112 6.66667 3.01887 6.66667 2.63397 6L0.468911 2.25C0.0840106 1.58333 0.565136 0.75 1.33494 0.75L5.66507 0.75C6.43487 0.75 6.91599 1.58333 6.53109 2.25L4.36602 6Z"
          fill="#8897AE"
        />
      </svg>
    </>
  );
}
